/**
 * Composable para usar Google Analytics en la aplicación
 * Proporciona funciones para rastrear eventos y páginas
 */

export const useAnalytics = () => {
  /**
   * Rastrear un evento personalizado
   * @param action - Nombre de la acción (ej: 'click_button', 'form_submit')
   * @param category - Categoría del evento (ej: 'engagement', 'conversion')
   * @param label - Etiqueta descriptiva opcional
   * @param value - Valor numérico opcional
   */
  const trackEvent = (
    action: string,
    category: string,
    label?: string,
    value?: number
  ) => {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', action, {
        event_category: category,
        event_label: label || '',
        value: value || undefined,
      })
    }
  }

  /**
   * Rastrear envío de formulario
   * @param formName - Nombre del formulario
   */
  const trackFormSubmit = (formName: string) => {
    trackEvent('form_submit', 'form', formName)
  }

  /**
   * Rastrear clic en enlace
   * @param linkText - Texto del enlace
   * @param linkUrl - URL del enlace
   */
  const trackLinkClick = (linkText: string, linkUrl: string) => {
    trackEvent('link_click', 'navigation', linkText, undefined)
  }

  /**
   * Rastrear reproducción de vídeo
   * @param videoTitle - Título del vídeo
   */
  const trackVideoPlay = (videoTitle: string) => {
    trackEvent('video_play', 'media', videoTitle)
  }

  /**
   * Rastrear descarga de archivo
   * @param fileName - Nombre del archivo
   */
  const trackDownload = (fileName: string) => {
    trackEvent('file_download', 'downloads', fileName)
  }

  /**
   * Rastrear pageview manual
   */
  const pageview = (path: string) => {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('config', 'G-LRQK1N61H5', {
        page_path: path
      })
    }
  }

  return {
    trackEvent,
    trackFormSubmit,
    trackLinkClick,
    trackVideoPlay,
    trackDownload,
    pageview,
  }
}
